import { Link } from "@StarberryUtils"
import * as React from "react"
import { Container } from "react-bootstrap"
import { GetURL } from "../../common/site/functions"
import Helmet from "react-helmet"
import { useLocation } from "@reach/router"
import {
  parseSearchUrl,
  propertyH1,
  savedSearchParams
} from "../../property-search/utils";
import "./Breadcrumb.scss"
import useDeviceMedia from "../../utils/useDeviceMedia";
// markup

const Breadcrumb = props => {
  const crtLocation = useLocation()
  const { isMobile } = useDeviceMedia({ max: "767px" });
  const [schemaList, setSchemaList] = React.useState([]);
  const [isFullTextVisible, setFullTextVisible] = React.useState(false);
  let url_1 = ""
  if (props.data.Main_Parent) {
    url_1 = GetURL(props.data.Main_Parent.id)
    if (url_1 == "about-dacha") {
      url_1 = "about-dacha/our-story"
    }
  }
  let url_2 = ""
  if (props.data.Sub_Parent) {
    url_2 = GetURL(props.data.Sub_Parent.id)
  }
  let index = 1
  if (crtLocation?.href?.endsWith("/")) {
    index = 2
  }

  /**  logic to display the current h1 in breadcrumb for results page **/
    let minPrice = typeof window !== 'undefined' ? localStorage.getItem('minPrice') : null
    let maxPrice = typeof window !== 'undefined' ? localStorage.getItem('maxPrice') : null
    const pType =
    props?.params?.ptype ||
    props?.ptype ||                                 // if direct ptype exists
    (props?.fullpathname?.includes("/for-sale/") ? "sales" :
    props?.fullpathname?.includes("/for-rent/") ? "lettings" : null);

    const searchParams = parseSearchUrl(pType, props.fullpathname, minPrice, maxPrice);
    let results_title = "";
    if (searchParams && Object.keys(searchParams).length > 0) {
      results_title = propertyH1(searchParams, false);
    }
    /**  logic to display the current h1 in breadcrumb for results page **/


  let urlIndex = crtLocation?.href?.split("/")

  let backUrl = urlIndex?.slice(0, urlIndex?.length - index).join("/")

  var elementList = [{ title: "Dacha Real Estate", url: crtLocation?.origin }]

  if (props.data.Main_Parent) {
    elementList.push({
      title: props.data.Main_Parent.Label,
      url: `${crtLocation?.origin}/${url_1}`,
    })
  }
  if (props.data.Sub_Parent) {
    elementList.push({
      title: props.data.Sub_Parent.Label,
      url: `${crtLocation?.origin}/${url_2}`,
    })
  }

  if (props.category && props.url != undefined) {
    elementList.push({
      title: props.category.replace(/-|\s/g, " "),
      //url: `${crtLocation?.origin}/${props.url}`,
      url:`${crtLocation?.origin}/${props.url}${props.url.endsWith('/') ? '' : '/'}`,
    })
  }
  if (props.category && props.url == undefined) {
    elementList.push({
      title: props.category.replace(/-|\s/g, " "),
      url: `${backUrl}`,
    })
  }

  if (props.page && (props.tag === "" || props.tag === undefined)) {
    elementList.push({ title: props.page, url: crtLocation?.href })
  }

  if (props.tag) {
    let element = {
      title: props.name.replace(/\s*-\s*/g, " ").trim(),
      url: crtLocation?.href,
    };
  
    if (props.name === "Properties For sale" || props.name === "Properties For rent") {
      if (crtLocation && crtLocation.href) {
      const segments = crtLocation?.href.split("/").filter(segment => segment.trim() !== "");
      
      if (segments.length >= 3) {
        element.url = segments.slice(0, 5).join("/")+"/";
      }
    }}
      elementList.push(element);
  }
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const formatName = (name) => {
    const formattedName = name.replace(/-|\s+/g, " ").trim();
    const words = formattedName.split(" ");
    return words.length > 6 ? words.slice(0, 6).join(" ") + "" : formattedName;
  };
  const handleToggleText = () => {
    setFullTextVisible(prevState => !prevState);
  };
  const shouldShowEllipsis = props.name && props.name.length > 20 && isMobile && !isFullTextVisible;



  // var schemaList = [];
  // elementList.forEach((item, i)=>{
  //   schemaList.push({
  //       "@type": "ListItem", 
  //       "position": i+1, 
  //       "name": item?.title,
  //       "item":  item?.url
  //   })
  // })
  React.useEffect(() => {
    const newSchemaList = elementList.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.title,
      "item": item.url
    }));
  
    // Only update schemaList if it has changed
    setSchemaList(prevSchemaList => {
      const isSameList = JSON.stringify(prevSchemaList) === JSON.stringify(newSchemaList);
      return isSameList ? prevSchemaList : newSchemaList;
    });
  }, [elementList]);
  
  const categoryName = props?.category?.replace(/-/g, " ").replace(/\b\w/g, char => char.toUpperCase());
 
  return (
    <React.Fragment>
      <Helmet>
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org/", 
            "@type": "BreadcrumbList", 
            "itemListElement": ${JSON.stringify(schemaList, null, 2)}
            }`}
        </script>
      </Helmet>
      <section className="breadcrumb-wrap">
        <Container>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb text-xxs">
              <li className="breadcrumb-item one ">
                <Link to="/">Home</Link>
              </li>
              {props.data.Main_Parent && (
                <li className="breadcrumb-item one ">
                  <Link to={`/${url_1}`}>{props.data.Main_Parent.Label}</Link>
                </li>
              )}
              {props.data.Sub_Parent && (
                <li className="breadcrumb-item one ">
                  <Link to={`/${url_2}`}>{props.data.Sub_Parent.Label}</Link>
                </li>
              )}

              {props.category && props.url != undefined ? (
                <li className="breadcrumb-item one">
                  <Link to={`/${props.url}`}>{categoryName}</Link>
                </li>
              ) : (
                ""
              )}

              {props.category && props.url == undefined ? (
                <li className="breadcrumb-item one">
                  <Link to="../">{categoryName}</Link>
                </li>
              ) : (
                ""
              )}

              {(props.tag === "" || props.tag === undefined) && props.page && (
                <li className="breadcrumb-item active">{props.page}</li>
              )}
              {props.tag === "details" ? (
                <li className="breadcrumb-item active" aria-current="page">
                  <span onClick={handleToggleText} style={{ cursor: 'pointer' }}>
                    {isFullTextVisible || !isMobile
                      ? capitalizeFirstLetter(props.name.replace(/-|\s/g, " "))
                      : formatName(props.name)}
                    {shouldShowEllipsis && " ..."}
                  </span>
                </li>
              ) : (
                ""
              )}
              {props.tag === "detail-page" ? (
                <>
                <li className="breadcrumb-item two" >
                  <Link to={props?.link}>{props.name.replace(/-|\s/g, " ")}</Link>
                </li>

                  {results_title && results_title !== props.name.replace(/-|\s/g, " ") && (
                    <li className="breadcrumb-item active" aria-current="page">
                      {results_title}
                    </li>
                  )}
                </>
              ) : (
                ""
              )}
            </ol>
          </nav>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default Breadcrumb